import axios from 'axios'
// import Vue from 'vue'
// import Loading from 'muse-ui-loading'
// import 'muse-ui-loading/dist/muse-ui-loading.css'

import bhUi from '../../components/bh-ui'

// axios.defaults.headers.common['channel'] = sessionStorage.getItem('chlCode') || ''
// axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token') || ''

const closeLoading = () => {
    if (window.loading && window.loading.instance) {
        window.loading.close()
    }
}
// var loading
// 请求拦截器
axios.interceptors.request.use(
    config => {
    // 在发送请求之前做些什么
        // console.log(window.loading)
        // if (!window.loading || !window.loading.instance) {
        //     window.loading = Loading()
        // }
        let chlCode = sessionStorage.getItem('chlCode');
        let token = sessionStorage.getItem('token');
        if (chlCode) {
            config.headers.channel = chlCode
        }
        if (token) {
            config.headers.Authorization = token
        }
        return config
    }, 
    error => {
    // 对请求错误做些什么
        closeLoading()
        return Promise.reject(error)
    }
)


// 响应拦截（配置请求回来的信息）
axios.interceptors.response.use(
    response => {
        closeLoading()
        if (response.data.code != 200) {
            // console.log(response)
            response.data.msg ? bhUi.Toast({text: response.data.msg}) : null
            // Toast.error({
            //     message: response.data.msg
            // })
            return response
        }
        return response.data
        // console.log(window.loading)
    }, 
    error => {
        closeLoading()
        return Promise.reject(error)
    }
)

// export { setToken, setOpenId }